export enum ErrorCode {
    // 400 errors
    INVALID_REQUEST = "INVALID_REQUEST",
    INVALID_BILLING_CARD = "INVALID_BILLING_CARD",
    DUP_ENTRY = "DUP_ENTRY",
    VALIDATE_DATA_MISSING = "VALIDATE_DATA_MISSING",
    VALIDATION_FAILED = "VALIDATION_FAILED",

    // 401 errors
    AUTHORIZATION_REQUIRED = "AUTHORIZATION_REQUIRED",
    MUST_AUTHENTICATE = "MUST_AUTHENTICATE",

    // 402 errors
    ASSESSMENT_QUOTA_REACHED = "ASSESSMENT_QUOTA_REACHED",

    // 404 errors
    RECORD_NOT_FOUND = "RECORD_NOT_FOUND",
    
    // 500 errors
    SYSTEM_ERROR = "SYSTEM_ERROR",
    RECORD_CREATE_FAILED = "RECORD_CREATE_FAILED",
}

export class ErrorCodeStatus {
    private codeMap:any;
    static instance:ErrorCodeStatus;

    constructor() {
        this.codeMap = {};
        this.codeMap[ErrorCode.DUP_ENTRY] = 400;
        this.codeMap[ErrorCode.INVALID_REQUEST] = 400;
        this.codeMap[ErrorCode.VALIDATE_DATA_MISSING] = 400;
        this.codeMap[ErrorCode.VALIDATION_FAILED] = 400;
        this.codeMap[ErrorCode.INVALID_BILLING_CARD] = 400;
        this.codeMap[ErrorCode.AUTHORIZATION_REQUIRED] = 401;
        this.codeMap[ErrorCode.MUST_AUTHENTICATE] = 401;
        this.codeMap[ErrorCode.ASSESSMENT_QUOTA_REACHED] = 402;
        this.codeMap[ErrorCode.RECORD_NOT_FOUND] = 404;
        this.codeMap[ErrorCode.SYSTEM_ERROR] = 500;
        this.codeMap[ErrorCode.RECORD_CREATE_FAILED] = 500;
    }
    static getStatusForErrorCode(code:ErrorCode) : number {
        if (!ErrorCodeStatus.instance) {
            ErrorCodeStatus.instance = new ErrorCodeStatus();
        }
        
        let status = ErrorCodeStatus.instance.codeMap[ErrorCode.SYSTEM_ERROR];
        if (ErrorCodeStatus.instance.codeMap[code]) {
            status =  ErrorCodeStatus.instance.codeMap[code];
        }
        return status;
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/models/ErrorCodes.ts